'use client';
import { Button, Icon } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { icon } from '@mage-ui/styled-system/recipes';
import { input, inputRoot, selectBadge } from '@mage-ui/styled-system/recipes';
import { Menu as MantineMenu } from '@mantine/core';
import { useState } from 'react';
import { FilterBadge } from './FilterBadge';

export const SelectBadge = ({
  data,
  texts,
  setValue,
  classNames,
  selectedBadges,
  ...props
}) => {
  const [selectedItems, setSelectedItems] = useState(selectedBadges || []);

  const displayLabel =
    selectedItems.length > 0
      ? data.items
          .filter((item) => selectedItems.includes(item.value))
          .map((item) => item.label)
          .join(', ')
      : (data.label ??
        (data.items?.[0]?.fields?.label || data.items?.[0]?.label || ''));

  return (
    <MantineMenu
      offset={0}
      withinPortal={false}
      keepMounted={true}
      menuItemTabIndex={0}
      {...props}
    >
      <MantineMenu.Target>
        <Button
          type='button'
          aria-selected={!!selectedItems || null}
          endSlot={
            <Icon
              name='arrow_drop_down'
              classNames={icon({ size: 'm' })}
              aria-hidden='true'
            />
          }
          classNames={{
            root: cx(classNames, inputRoot(), selectBadge().root),
            inner: cx(classNames, input(), selectBadge().input),
            label: cx(classNames, selectBadge().label),
            section: cx(classNames, selectBadge().section),
          }}
        >
          {selectedItems.length > 0 ? displayLabel : texts.placeholder}
        </Button>
      </MantineMenu.Target>
      <MantineMenu.Dropdown
        classNames={{
          dropdown: cx(classNames, selectBadge().dropdown),
        }}
      >
        {data.items.map((item) => {
          const itemValue = item?.fields?.value || item.value;

          if (
            (item?.fields?.label || item.label) === undefined ||
            (item?.fields?.label || item.label) === ''
          ) {
            return null;
          }

          return (
            <FilterBadge
              key={itemValue}
              selectedItem={selectedItems}
              onClick={() => {
                const newSelected = selectedItems.includes(itemValue)
                  ? selectedItems.filter((v) => v !== itemValue)
                  : [...selectedItems, itemValue];

                setSelectedItems(newSelected);
                setValue?.(newSelected);
              }}
              data={{
                id: item?.meta?.id || item.id,
                value: item?.fields?.value || item.value,
                name: item?.fields?.name || item.name,
                label: item?.fields?.label || item.label,
              }}
            />
          );
        })}
      </MantineMenu.Dropdown>
    </MantineMenu>
  );
};
